export const ENCRYPTION_KEY = 'mrsoftyruday1234';
export const IV_KEY = 'mrsoftyruday1234';